import { generateSignalDataAccess } from '@/react/utils/generateSignalDataAccess'

import { SrmEventLog } from './SrmEventLog'

export const [srmEventLog0, makeSrmEventLogAvailable] = generateSignalDataAccess(SrmEventLog)
